import { CurrentCardService, MyCardService } from '@addins/core/core';
import { CardTool, CardToolsGroup, CardToolsProviderService } from '@addins/core/singlecallcard';
import { AttachmentService, MediaSource } from '@addins/media';
import { Injectable } from '@angular/core';

interface AddAttachmentTool {
  mediaSource: MediaSource;
  tool: CardTool;
}

@Injectable()
export class AddAttachmentToolsControllerService {
  private _addAttachmentToolsGroup: CardToolsGroup;
  get addAttachmentToolsGroup(): CardToolsGroup {
    return this._addAttachmentToolsGroup;
  }

  private _fromMyCallcardOnly: boolean;
  get fromMyCallcardOnly(): boolean {
    return this._fromMyCallcardOnly;
  }

  constructor(
    private attachmentService: AttachmentService,
    private cardToolsProvider: CardToolsProviderService,
    private currentCardService: CurrentCardService,
    private myCardService: MyCardService
  ) {}

  setup(addAttachmentSources: string[], fromMyCallcardOnly: boolean) {
    this._fromMyCallcardOnly = fromMyCallcardOnly;
    const mediaSources: MediaSource[] = [];
    addAttachmentSources.forEach(attachmentSource => mediaSources.push(MediaSource[attachmentSource]));

    this._addAttachmentToolsGroup = this.createAddAttachmentToolsGroup(mediaSources);

    if (fromMyCallcardOnly) {
      this.currentCardService.$change.subscribe(() => this.onCardChanged());
      this.myCardService.$change.subscribe(() => this.onCardChanged());
    } else {
      this.cardToolsProvider.addCardToolsGroup(this._addAttachmentToolsGroup);
    }
  }

  private createAddAttachmentToolsGroup(mediaSources: MediaSource[]): CardToolsGroup {
    const addAttachmentTools: AddAttachmentTool[] = [
      {
        mediaSource: MediaSource.Camera,
        tool: new CardTool('Mobile.AddPhoto', cardId => this.attachmentService.createAttachment(cardId, MediaSource.Camera))
      },
      {
        mediaSource: MediaSource.Video,
        tool: new CardTool('Mobile.AddVideo', cardId => this.attachmentService.createAttachment(cardId, MediaSource.Video))
      },
      {
        mediaSource: MediaSource.Gallery,
        tool: new CardTool('Mobile.AddImage', cardId => this.attachmentService.createAttachment(cardId, MediaSource.Gallery))
      },
      {
        mediaSource: MediaSource.File,
        tool: new CardTool('Mobile.AddFile', cardId => this.attachmentService.createAttachment(cardId, MediaSource.File))
      }
    ];

    const addAttachmentToolsGroup: CardToolsGroup = new CardToolsGroup('Mobile.AddAttachment', 100);
    addAttachmentTools
      .filter(addAttachmentTool => mediaSources.includes(addAttachmentTool.mediaSource))
      .forEach(addAttachmentTool => addAttachmentToolsGroup.tools.push(addAttachmentTool.tool));

    return addAttachmentToolsGroup;
  }

  private onCardChanged() {
    const isMyCard: boolean =
      this.myCardService.myCard !== null &&
      this.currentCardService.current !== null &&
      this.currentCardService.current.ObjGuid === this.myCardService.myCardId;

    if (isMyCard) {
      this.cardToolsProvider.addCardToolsGroup(this._addAttachmentToolsGroup);
    } else {
      this.cardToolsProvider.removeCardToolsGroup(this._addAttachmentToolsGroup);
    }
  }
}
